

















import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "../cz/CzCard.vue";
import CzChip from "../cz/CzChip.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzCover from "../cz/CzCover.vue";

// A program on sale: cover (photo or name), length, price and the way in.
@Component({ components: { CzCard, CzChip, CzTitle, CzCover } })
export default class ProgramCard extends Vue {
  @Prop({ type: String, required: true }) to!: string;
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) price!: string;
  @Prop({ type: String, default: "" }) priceNote!: string;
  @Prop({ type: String, default: "" }) goLabel!: string;
}
